module.exports = __webpack_public_path__ + "static/media/logo.664f1bda.png";